import { CreditCard } from "lucide-react";
import { paymentStyle } from "@/lib/constants";

export const PaymentBadge = ({ method, methods }) => {
  if (!method) return <span className="text-sm text-slate-400">—</span>;
  const s = paymentStyle(method, methods);
  return (
    <span
      data-testid="payment-method-badge"
      className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium"
      style={{ backgroundColor: s.bg, color: s.text }}
    >
      <CreditCard className="h-3.5 w-3.5" />
      {method}
    </span>
  );
};

export const PaymentBadges = ({ list, methods }) => {
  const items = Array.isArray(list) ? list.filter(Boolean) : [];
  if (items.length === 0) return <span className="text-sm text-slate-400">—</span>;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="payment-methods-list">
      {items.map((m) => (
        <PaymentBadge key={m} method={m} methods={methods} />
      ))}
    </div>
  );
};
